import { render, staticRenderFns } from "./PartnerCards.vue?vue&type=template&id=57057e05&scoped=true"
import script from "./PartnerCards.vue?vue&type=script&lang=js"
export * from "./PartnerCards.vue?vue&type=script&lang=js"
import style0 from "./PartnerCards.vue?vue&type=style&index=0&id=57057e05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57057e05",
  null
  
)

export default component.exports